/** Koliko se naziva ispiše prije nego se ostatak sažme u „(+n)". */
export const NAMES_SHOWN = 3;
